import React, { useState } from 'react';
import StripeOnboardingComponent from 'components/StripeOnboardingComponent';
import { Modal } from 'antd';
import StripeFail from 'assets/payment/StripeFail.png';
import { confirmAccountConnect } from 'api/paymentSetup';
import s from './s.module.less';

interface Props {
    showStripeModal: boolean;
    onClose: (isExit: boolean) => void;
    clientSecret: string;
}

const StripeModal: React.FC<Props> = ({ showStripeModal, onClose, clientSecret }) => {
    const [showUnhappyModal, setShowUnhappyModal] = useState(false);
    const [isExit, setIsExit] = useState(false);

    const onExit = async () => {
        try {
            await confirmAccountConnect();
            setIsExit(true);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <Modal
                open={showStripeModal}
                onCancel={() => onClose(isExit)}
                footer={null}
                width={872}
                className={s.modal}
                title="Secure your payment setup with Stripe"
            >
                <div className={s.description}>
                    To securely receive payments, you’ll be redirected to Stripe to confirm your business and payment details. After submission, your account status will update automatically. You may close this window and continue with the next steps. If any additional information is needed, our support team will contact you.
                </div>
                <div className={s.stripeContainer}>
                    <StripeOnboardingComponent client_secret={clientSecret} onExit={onExit} />
                </div>
            </Modal>
            <Modal
                open={showUnhappyModal}
                onCancel={() => setShowUnhappyModal(false)}
                footer={null}
                width={1222}
            >
                <div className={s.unhappyModalContainer}>
                    <img className={s.unhappyModalImage} src={StripeFail} alt="unhappy-stripe" />
                    <div className={s.unhappyModalTitle}>
                        Stripe was unable to verify your payout account
                    </div>
                    <div className={s.unhappyModalDescription}>
                        <div>Stripe wasn’t able to approve your payout account with the information provided.</div>
                        <div>Don’t worry — our support team is here to help. If you have any questions or need assistance, feel free to reach out to us at <a href="mailto:support@kiwihealth.com">support@kiwihealth.com</a>.</div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default StripeModal;
